import './skill-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { HypervisionState } from '@hypervision/hypervision-routing.module';
import { forEach, IChangesObject, IComponentController, IComponentOptions, isDefined } from 'angular';
import { distinctUntilChanged, Subject } from 'rxjs';

import { MessagingService } from '@contact/upgrade';

import { ISkillViewFilterService } from '../filter.service';
import templateUrl from './skill-filter.component.ajs.html';

const MODULE_NAME = 'skillViewSkillFilter';

class SkillFilterCtrl implements IComponentController {
  public name = MODULE_NAME;

  private skillChanged$: Subject<any[]> = new Subject();

  public filterView: string;
  public onChangeFilterView: Function;
  public skills: any[];

  public currentView: string = 'filterSkills';
  public selectedSkills: any[] = [];
  public initialisation = true;

  constructor(private readonly skillFilterHypervision: ISkillViewFilterService, private readonly messaging: MessagingService) {}

  $onInit() {
    // domainFilterChange
    this.messaging
      .forLocal()
      .listen$('domainFilterChange')
      .pipe(ng1Destroy(this))
      .subscribe((data: any) => {
        if (data.viewName === HypervisionState.SKILL_CUSTOM) {
          this.filterAvailableSkills(data.domainUuids, data.toggledDomainUuid);
        }
      });
    // filterChanged
    this.messaging
      .forLocal()
      .listen$('filterChanged')
      .pipe(ng1Destroy(this))
      .subscribe((data: any) => {
        if (data !== undefined && data.emitter === 'SkillTableCtrl') {
          let f = this.skillFilterHypervision.getFilter(HypervisionState.SKILL_CUSTOM);
          if (isDefined(f)) {
            this.selectedSkills = [];
            forEach(this.skills, currentSkill => {
              if (f.skillUuids.indexOf(currentSkill.uuid) >= 0) {
                this.selectedSkills.push(currentSkill);
              }
            });
            this.skillChanged$.next(this.selectedSkills);
          }
        }
      });
    // skill changed
    this.skillChanged$
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x, y) => x === y,
          v => JSON.stringify(v)
        ),
        ng1Destroy(this)
      )
      .subscribe(v => {
        let skillUuids = v.map(skill => skill.uuid);
        this.skillFilterHypervision.notifySkillChange(HypervisionState.SKILL_CUSTOM, skillUuids);
        this.messaging.forLocal().publish('filterChanged', { emitter: 'SkillPersoSkillFilterCtrl' });
      });

    let filter = this.skillFilterHypervision.getFilter(HypervisionState.SKILL_CUSTOM);
    if (isDefined(filter) && this.skills.length > 0) {
      this.filterAvailableSkills(this.skillFilterHypervision.getFilter(HypervisionState.SKILL_CUSTOM).domainUuids);
    }
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['skills'] && isDefined(onChangesObj['skills'].currentValue)) {
      this.skills = onChangesObj['skills'].currentValue;

      let filter = this.skillFilterHypervision.getFilter(HypervisionState.SKILL_CUSTOM);
      if (isDefined(filter) && this.skills.length > 0) {
        this.filterAvailableSkills(filter.domainUuids);
      }
    }
    if (onChangesObj['filterView'] && isDefined(onChangesObj['filterView'].currentValue)) {
      this.filterView = onChangesObj['filterView'].currentValue;
    }
  }

  selectSkills() {
    this.skillChanged$.next(this.selectedSkills);
  }

  filterAvailableSkills(domainUuids, toggledDomainUuid?: any) {
    let filteredSkills: any[] = [];
    let filteredSelectedSkill: any[] = [];
    forEach(this.skills, skill => {
      if (domainUuids.indexOf(skill.domain.domainUuid) >= 0) {
        filteredSkills.push(skill);
        skill.chosen = false;
        skill.selected = false;
        skill.displayed = false;
      }
    });
    this.skills = filteredSkills;

    let filteredSkillUuids: any[] = [];
    forEach(filteredSkills, skill => {
      if (domainUuids.indexOf(skill.domain.domainUuid) >= 0) {
        filteredSelectedSkill.push(skill);
        filteredSkillUuids.push(skill.uuid);
        skill.chosen = true;
        skill.selected = true;
        skill.displayed = true;
      }
    });

    // for domains added to selection, we add all skills of the domain
    if (isDefined(toggledDomainUuid) && domainUuids.indexOf(toggledDomainUuid) >= 0) {
      forEach(this.skills, skill => {
        if (toggledDomainUuid === skill.domain.domainUuid && filteredSkillUuids.indexOf(skill.uuid) < 0) {
          filteredSelectedSkill.push(skill);
          skill.chosen = true;
          skill.selected = true;
          skill.displayed = true;
        }
      });
    }
    this.selectedSkills = filteredSelectedSkill;
  }

  isCurrentFilterView(): boolean {
    return this.filterView === this.currentView;
  }

  changeView() {
    this.onChangeFilterView({ $event: { filterView: this.currentView } });
  }
}

export class SkillFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    filterView: '<',
    onChangeFilterView: '&',
    skills: '<',
  };
  controller = ['skillFilterHypervision', 'messaging', SkillFilterCtrl];
}

export default MODULE_NAME;
